/**
 * Determines whether the browser understands the third argument of addEventListener to
 * be an object containing a 'passive' property. If false, then the browser expects the
 * third argument to be a boolean - useCapture.
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 */
function getPassiveSupport(): boolean {
  let passiveSupported = false;

  try {
    const options: AddEventListenerOptions = {
      get passive() { // This function will be called when the browser
        //   attempts to access the passive property.
        passiveSupported = true;
        return false;
      }
    };

    window.addEventListener("test", null, options);
    window.removeEventListener("test", null, options);
  } catch (err) {
    passiveSupported = false;
  }

  return passiveSupported;
}

/**
 * Does the current browser support calling addEventListener where the third argument
 * is an object with a 'passive' property?
 */
export const passiveSupported: boolean = getPassiveSupport();
